import config from './config';
import {GET, PATCH, POST, DELETE} from '@strangeanimals/common-vue-components/src/helpers/api';
import {isArray} from "@strangeanimals/common-vue-components/src/helpers/helpers";

/** **************************** */
/** ** Payment Controller ****** */
/** **************************** */
const paymentAppController = [config.apiUrl, 'payment', 'app'].join('/');
const getAuthKeyURL = [paymentAppController, 'getAuthKey'].join('/');
const verifyPaymentURL = [paymentAppController, 'verify'].join('/');
const updateUserDetailsURL = [paymentAppController, 'updateUserDetails'].join('/');
const paymentsURL = [paymentAppController, 'payments'].join('/');
const processCashURL = [paymentAppController, 'cash'].join('/');
const processChequeURL = [paymentAppController, 'cheque'].join('/');
const processEftURL = [paymentAppController, 'eft'].join('/');
const sendBpointPaymentLinkURL = [paymentAppController, 'sendBpointPaymentLink'].join('/');
const resendBpoinPaymentLinkURL = [paymentAppController, 'resendBpointPaymentLink'].join('/');
const getJobDetailsURL = [paymentAppController, 'getJobDetails'].join('/');
const updatePaymentURL = [paymentAppController, 'updatePayment'].join('/');
const paymentAttachmentURL = [paymentAppController, 'paymentAttachment'].join('/');
const getUserDetailsByEmailURL = [paymentAppController, 'getUserDetailsByEmail'].join('/');
const getPaymentFormDropdownItemsURL = [paymentAppController, 'paymentFormDropdownItems'].join('/');
const getEmailAddressesURL = [paymentAppController, 'getEmailAddresses'].join('/');
const getReceiptLinkURL = [paymentAppController, 'receiptLink'].join('/');
const getDepositSlipLinkURL = [paymentAppController, 'depositSlipLink'].join('/');
const getReportLinkURL = [paymentAppController, 'reportLink'].join('/');
const deletePaymentURL = [paymentAppController, 'deletePayment'].join('/');
const computeAmountAndSurchargeURL = [paymentAppController, 'computeAmountAndSurcharge'].join('/');

const apiVersion = 'v3';
export const refundRequestController = [config.apiUrl, apiVersion, 'refund-requests'].join('/');
export const opportunitiesController = [config.apiUrl, apiVersion, 'opportunities'].join('/');
export const paymentsAppSettingsController = [config.apiUrl, apiVersion, 'app-state-based-settings'].join('/');
export const buildRegionStatesController = [config.apiUrl, apiVersion, 'build-region-states'].join('/');
export const appsController = [config.apiUrl, apiVersion, 'apps'].join('/');

function convertObjectToGetParams(object) {
    let params = [];
    Object.keys(object).forEach(function(key) {
        if (isArray(object[key])) {
            for (let value of object[key]) {
                params.push(key + "[]=" + value);
            }
        } else {
            params.push(key + "=" + object[key]);
        }
    });
    return params.join('&');
}

export function getAuthKeyRequest(params) {
    return POST(getAuthKeyURL, params);
}

export function verifyPaymentRequest(params) {
    return POST(verifyPaymentURL, params);
}

export function updateUserDetailsRequest(params) {
    return POST(updateUserDetailsURL, params);
}

export function paymentListRequest(params) {
    return POST(paymentsURL, params);
}

export function getPaymentPayloadRequest(id) {
    return GET(paymentsURL + "/" + id);
}

export function processCashRequest(params) {
    return POST(processCashURL, params);
}

export function processChequeRequest(params) {
    return POST(processChequeURL, params);
}

export function processEftRequest(params) {
    return POST(processEftURL, params);
}

export function sendBpointPaymentLinkRequest(params) {
    return POST(sendBpointPaymentLinkURL, params);
}

export function resendBpoinPaymentLinkRequest(token, params) {
    return POST(resendBpoinPaymentLinkURL + "/" + token, params);
}

export function getJobDetailsRequest(params) {
    return POST(getJobDetailsURL, params);
}

export function updatePaymentRequest(params) {
    return POST(updatePaymentURL, params);
}

export function deletePaymentAttachmentRequest(id) {
    return DELETE(paymentAttachmentURL + "/" + id);
}

export function getUserDetailsByEmailRequest(params) {
    return POST(getUserDetailsByEmailURL, params);
}

export function getPaymentFormDropdownItemsRequest(params) {
    return POST(getPaymentFormDropdownItemsURL, params);
}

export function getEmailAddressesRequest(params) {
    return POST(getEmailAddressesURL, params);
}

export function getReceiptLinkRequest(id, params) {
    return POST(getReceiptLinkURL + "/" + id, params);
}

export function getDepositSlipLinkRequest(params) {
    return POST(getDepositSlipLinkURL, params);
}

export function getReportLinkRequest(params) {
    return POST(getReportLinkURL, params);
}

export function deletePaymentRequest(params) {
    return POST(deletePaymentURL, params);
}

export function computeAmountAndSurchargeRequest(params) {
    return POST(computeAmountAndSurchargeURL, params);
}

export function getRefundRequests(params) {
    let getParams = convertObjectToGetParams(params);
    return GET([refundRequestController, getParams].join("?"));
}

export function getGroupedRefundRequests(params) {
    let getParams = convertObjectToGetParams(params);
    let url = [refundRequestController, 'grouped'].join('/');
    return GET([url, getParams].join("?"));
}

export function getRefundRequestByToken(token) {
    let url = [refundRequestController, token].join('/');
    return GET(url);
}

export function getRequestedRefundRequests(params) {
    let url = [refundRequestController, 'requested'].join('/');
    return GET(url, true, params);
}

export function getProcessedRefundRequests(params) {
    let url = [refundRequestController, 'processed'].join('/');
    return GET(url, true, params);
}

export function getToBeApprovedRefundRequests(params) {
    let url = [refundRequestController, 'to-be-approved'].join('/');
    return GET(url, true, params);
}

export function getToBeVerifiedRefundRequests(params) {
    let url = [refundRequestController, 'to-be-verified'].join('/');
    return GET(url, true, params);
}

export function getSingleRefundRequest(token) {
    let url = [refundRequestController, token].join('/');
    return GET(url);
}

export function downloadSingleRefundRequest(token, apiAccessToken) {
    let url = [refundRequestController, 'download', token].join('/');
    return fetch(url, {
        method: 'GET',
        headers: {
            Authorization: 'Bearer ' + apiAccessToken,
        },
    })
}

export function getOpportunities(params) {
    let getParams = convertObjectToGetParams(params);
    return GET([opportunitiesController, getParams].join("?"));
}

export function getGroupedOpportunities(params) {
    let getParams = convertObjectToGetParams(params);
    let url = [opportunitiesController, 'grouped'].join('/');
    return GET([url, getParams].join("?"));
}

export function getToBeApprovedOpportunities(params) {
    let url = [opportunitiesController, 'to-be-approved'].join('/');
    return GET(url, true, params);
}

export function getToBeVerifiedOpportunities(params) {
    let url = [opportunitiesController, 'to-be-verified'].join('/');
    return GET(url, true, params);
}

export function verifyRefundRequest(params) {
    let url = [refundRequestController, 'verify'].join('/');
    return PATCH(url, params)
}

export function approveRefundRequest(params) {
    let url = [refundRequestController, 'approve'].join('/');
    return PATCH(url, params)
}

export function rejectRefundRequest(params) {
    let url = [refundRequestController, 'reject'].join('/');
    return PATCH(url, params)
}

export function cancelRefundRequest(params) {
    let url = [refundRequestController, 'cancel'].join('/');
    return PATCH(url, params)
}

export function updateRefundRequestStatus(params) {
    let url = [refundRequestController, 'status'].join('/');
    return PATCH(url, params)
}

export function getPaymentsAppSettings(params) {
    let getParams = convertObjectToGetParams(params);
    return GET([paymentsAppSettingsController, getParams].join("?"));
}

export function createPaymentsAppSettings(params) {
    return POST(paymentsAppSettingsController, params);
}

export function updatePaymentsAppSettings(id, params) {
    return PATCH([paymentsAppSettingsController, id].join("/"), params);
}

export function deletePaymentsAppSettings(id) {
    return DELETE([paymentsAppSettingsController, id].join("/"));
}

export function getBuildRegionStates(params) {
    let getParams = convertObjectToGetParams(params);
    return GET([buildRegionStatesController, getParams].join("?"));
}

export function getApps(params) {
    let getParams = convertObjectToGetParams(params);
    return GET([appsController, getParams].join("?"));
}